export enum OrgModelName {
  licenseInfoVisibility = 'LicenseInfoVisibility',
  inviteUserVisibility = 'InviteUserVisibility',
  fetchingOrgUsers = 'FetchingOrgUsers',
  confirmInviteModal = 'ConfirmInviteModal',
  newUserModal = 'NewUserModal',
}
